import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import commonNetwork from "../../common/api/commonNetwork";
import { FetchResultType } from "../fetchTypes";
 

export const getUserInformation = createAsyncThunk(
  "/user/get",
  async (_, { rejectWithValue }) => {
    try {
      // authToken eklenecek cookie,local vs biryerden okunup
      const { data, errorMessage, isSuccess } = await commonNetwork.get("/user/get-user");
      if (isSuccess ) {
        return data;
      } else {
        return rejectWithValue(data);
      }
    } catch (e:any) {
      return rejectWithValue(e.data.message);
    }
  }
);
 
export type UserInfoType={
userName: string,
userCode: string,
userEmail: string,
userPhone:string,
userDesc:boolean
}

export interface userStateType  extends FetchResultType{
    userInformations:UserInfoType
}
export const userSlice = createSlice({
  name: "user",
  initialState: {
    userInformations: {},
    isfirmAvailable: true,
    isFetching: false,
    isSuccess: false,
    isError: false,
    errorMessage: "",
  },
  reducers: {
    clearState: (state) => {
      state.userInformations = {};
      state.isFetching = false;
      state.isSuccess = false;
      state.isError = false;
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserInformation.fulfilled, (state, { payload }) => {
      state.userInformations = payload;
      state.isFetching = false;
      state.isSuccess = true;
      state.isError = false; 
      return state;
    });
    builder.addCase(getUserInformation.rejected, (state, { payload }) => {
      state.isFetching = false;
      state.isError = true; 
      // state.errorMessage = payload.message;
    });
    builder.addCase(getUserInformation.pending, (state) => {
      state.isFetching = true;
    });
  },
});
export const { clearState } = userSlice.actions;

export const userSelector = (state:any) => state.user;

export const userReducer = userSlice.reducer;
